import React, { useState } from "react";
import Button from "../ui/Button";
import SelectField from "../ui/SelectField";
import { userType } from "../../helper/constant";

const UserTypeDialog = ({
  formData,
  closeDialog,
  setFormData,
  userTypeData,
  loginGoogle,
  ...props
}) => {
  const [focusedInput, setFocusedInput] = useState(null);

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        onClick={closeDialog}
      >
        <div
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-8 relative">
            {/* Top Gradient Line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2] rounded-t-xl"></div>
            <SelectField
              placeholder="I am signing as a..."
              value={formData?.userType ? formData?.userType : ""}
              id="my-select"
              options={userTypeData}
              onChange={(val) =>
                setFormData(() => ({
                  ...formData,
                  userType: val,
                  userTypeError: "",
                }))
              }
              focusedInput={focusedInput}
              setFocusedInput={setFocusedInput}
              error={formData?.userTypeError}
            />
            <div className="flex justify-center mt-5 ">
              <Button
                children={"Continuue"}
                onClick={loginGoogle} // Directly call the function without passing the event
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserTypeDialog;
